export function hideMessageLoader(messageElement) {
    // Hide the dots loader
    messageElement.find('.g-chatform-message-content-loader').hide();

    // Remove the pending state class to restore normal background/layout
    messageElement.removeClass('is-pending-response');
}
